import React from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Status } from 'shared/ui'
import { type IStatusProps } from 'shared/ui/Status'
import { type IAutomationLogExecutionStatus } from 'entities/Integrations/api/types'
import config from './config'

import styles from './styles.module.scss'

export const AutomationLogResultStatus = observer(
  ({
    status,
    failedReason,
    resultTitle,
    emphasis = 'high',
    onlyIcon,
    className,
  }: {
    status: IAutomationLogExecutionStatus
    failedReason?: string | null
    resultTitle?: string | null
    emphasis?: IStatusProps['emphasis']
    onlyIcon?: IStatusProps['onlyIcon']
    className?: string
  }) =>
    status && (
      <Status
        typographyProps={{
          ellipsis: true,
          tooltipProps: { label: failedReason || resultTitle },
          ariaLabel: 'AutomationLogResultStatus',
          tag: 'div',
          width: '100%',
        }}
        {...config({ failedReason, resultTitle })[status]}
        emphasis={emphasis}
        onlyIcon={onlyIcon}
        className={classNames(className, { [styles.failedReason]: status === 'failed' })}
      />
    )
)
